import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { IonButton, IonCheckbox, ModalController } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { serverTimestamp } from '@angular/fire/firestore';
import { ModalShellComponent } from '../ui/modal-shell/modal-shell.component';
import { EmployeeLegal } from './employee-legal';
import { UsersService } from '../services/users.service';
import { usesEmployeeEntry } from './employee-entry';

@Component({selector:'app-employee-welcome', imports:[ModalShellComponent, IonButton, IonCheckbox, TranslatePipe],
  templateUrl:'./employee-welcome.html', styleUrl:'./employee-welcome.scss', changeDetection:ChangeDetectionStrategy.OnPush})
export class EmployeeWelcome {
  private users = inject(UsersService);
  private modalController = inject(ModalController);
  readonly accepted = signal(false);
  readonly saving = signal(false);
  readonly error = signal(false);
  async showLegal(document: 'terms' | 'privacy') {
    const modal = await this.modalController.create({component:EmployeeLegal, componentProps:{document}, cssClass:['workspace-modal', 'stack-modal']});
    await modal.present();
  }

  async continue() {
    const user = this.users.currentUserS();
    if (!this.accepted() || this.saving() || !usesEmployeeEntry(user?.role)) {
return;
}
    this.saving.set(true); this.error.set(false);
    try {
      await this.users.updateOnly(user.guid, {acceptedTerms:serverTimestamp(), onboardingStatus:'completed'});
      await this.modalController.dismiss({workerAccepted:true});
    } catch {
 this.error.set(true); 
} finally {
 this.saving.set(false); 
}
  }
}
